// client/src/App.js
import {
  HashRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import CheckIn from "./pages/Check-In";
import CheckInName from "./pages/CheckInName";
import AddUser from "./pages/AddUser";
import AddEvent from "./pages/AddEvent";
import SidebarLayout from "./components/SidebarLayout";
import Login from "./pages/Login";
import ExpressCheckIn from "./pages/ExpressCheckIn";
import ProtectedRoute from "./components/ProtectedRoute";
import ReportsMaster from "./pages/ReportsMaster";
import MasterListPage from "./pages/MasterListPage";
import EventListPage from "./pages/EventListPage";
import CheckInList from "./pages/CheckInList";
import ImportData from "./pages/ImportData";
import MinistryListPage from "./pages/MinistryListPage";
import Footer from "./components/Footer";

// ✅ NEW: Kiosk page (public)
// import KioskMode from "./pages/KioskMode";
import KioskApp from "./pages/kiosk/KioskApp";

console.log("API URL:", process.env.REACT_APP_API_URL);

const AppRoutes = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const isKiosk = location.pathname.startsWith("/kiosk");

  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        {/* ✅ NEW: public kiosk route (no auth, no sidebar) */}
        {/* <Route path="/kiosk" element={<KioskMode />} /> */}
        <Route path="/kiosk-mode" element={<KioskApp />} />
        {/* If you plan nested kiosk screens later, you can use: path="/kiosk/*" */}

        {/* App (protected) routes – hidden on /login and /kiosk */}
        {!isLoginPage && !isKiosk && (
          <>
            <Route
              path="/"
              element={
                <ProtectedRoute
                  allowedRoles={["super_admin", "admin", "checkin_staff"]}
                >
                  <SidebarLayout>
                    <Dashboard />
                  </SidebarLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/checkin"
              element={
                <ProtectedRoute
                  allowedRoles={["super_admin", "admin", "checkin_staff"]}
                >
                  <SidebarLayout>
                    <CheckIn />
                  </SidebarLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/check-in-name"
              element={
                <ProtectedRoute
                  allowedRoles={["super_admin", "admin", "checkin_staff"]}
                >
                  <SidebarLayout>
                    <CheckInName />
                  </SidebarLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/checkin-list"
              element={
                <ProtectedRoute
                  allowedRoles={["super_admin", "admin", "checkin_staff"]}
                >
                  <SidebarLayout>
                    <CheckInList />
                  </SidebarLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/masterlist"
              element={
                <ProtectedRoute allowedRoles={["super_admin", "admin"]}>
                  <SidebarLayout>
                    <MasterListPage />
                  </SidebarLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/eventlist"
              element={
                <ProtectedRoute allowedRoles={["super_admin", "admin"]}>
                  <SidebarLayout>
                    <EventListPage />
                  </SidebarLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports-master"
              element={
                <ProtectedRoute allowedRoles={["super_admin", "admin"]}>
                  <SidebarLayout>
                    <ReportsMaster />
                  </SidebarLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-event"
              element={
                <ProtectedRoute allowedRoles={["super_admin", "admin"]}>
                  <SidebarLayout>
                    <AddEvent />
                  </SidebarLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/express"
              element={
                <ProtectedRoute
                  allowedRoles={["super_admin", "admin", "checkin_staff"]}
                >
                  <SidebarLayout>
                    <ExpressCheckIn />
                  </SidebarLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-user"
              element={
                <ProtectedRoute allowedRoles={["super_admin", "admin"]}>
                  <SidebarLayout>
                    <AddUser />
                  </SidebarLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/import-data"
              element={
                <ProtectedRoute allowedRoles={["super_admin", "admin"]}>
                  <SidebarLayout>
                    <ImportData />
                  </SidebarLayout>
                </ProtectedRoute>
              }
            />
            {/* Ministries CRUD */}
            <Route
              path="/ministries"
              element={
                <ProtectedRoute allowedRoles={["super_admin", "admin"]}>
                  <SidebarLayout>
                    <MinistryListPage />
                  </SidebarLayout>
                </ProtectedRoute>
              }
            />
          </>
        )}
      </Routes>

      {/* Hide footer on /login and /kiosk for clean screens */}
      {!isLoginPage && !isKiosk && <Footer />}
    </>
  );
};

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
